import { css } from 'react-emotion';
import { BackdropColor } from '.';

export namespace styles {
  export const root = (color: BackdropColor) =>
    css({
      zIndex: -1,
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      backgroundColor: color === 'dark' ? 'rgba(0, 0, 0, 0.5)' : '#FFF'
    });

  export const wrapper = css({
    opacity: 0,
    display: 'block',
    transition: 'opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
  });

  export const fade = {
    entering: css({
      opacity: 0,
      transform: 'translateZ(0.001px)'
    }),
    entered: css({
      opacity: 1
    }),
    exiting: css({
      opacity: 1
      // transitionDelay: '0.5'
    }),
    exited: css({
      opacity: 0
    })
  };
}
